import { render, staticRenderFns } from "./ComponentIcon.vue?vue&type=template&id=3e5b2315&"
import script from "./ComponentIcon.vue?vue&type=script&lang=js&"
export * from "./ComponentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports